import client from "directus/src/client";
import {
  customEndpoint,
  deleteItemFromCollection,
  deleteItemsFromCollection,
  getItemsFromCollection,
} from "directus/src/operations";

const INTEGRATION_COLLECTIONS = {
  github: "git_integrations",
  discord: "discord_integrations",
  drive: "drive_integrations",
  keka: "keka_integrations",
};
export async function connectIntegration({ provider, legalEntityId }) {
  try {
    const response = await client.request(
      customEndpoint({
        path: `/integration/${provider}/connect`,
        method: "GET",
        params: {
          legal_entity: legalEntityId,
        },
      }),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchKekaMeta({ legalEntityId }) {
  try {
    const query = {
      fields: ["id", "legal_entity"],
      filter: {
        legal_entity: {
          _eq: legalEntityId,
        },
      },
      limit: -1,
    };
    const data = await getItemsFromCollection("keka_integrations", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchDriveMeta({ legalEntityId }) {
  try {
    const query = {
      fields: ["id", "legal_entity"],
      filter: {
        legal_entity: {
          _eq: legalEntityId,
        },
      },
      limit: -1,
    };
    const data = await getItemsFromCollection("drive_integrations", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchDiscordMeta({ legalEntityId }) {
  try {
    const query = {
      fields: ["id", "legal_entity"],
      filter: {
        legal_entity: {
          _eq: legalEntityId,
        },
      },
      limit: -1,
    };
    const data = await getItemsFromCollection("discord_integrations", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchGithubMeta({ legalEntityId }) {
  try {
    const query = {
      fields: ["id", "legal_entity"],
      filter: {
        legal_entity: {
          _eq: legalEntityId,
        },
      },
      limit: -1,
    };
    const data = await getItemsFromCollection("git_integrations", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchEntity({ legalEntityId }) {
  try {
    const query = {
      fields: ["id", "name", "status"],
      filter: {
        id: {
          _eq: legalEntityId,
        },
      },
      limit: 1,
    };
    const data = await getItemsFromCollection("legal_entities", query);
    return data[0];
  } catch (error) {
    console.log(error);
    throw error;
  }
}

async function deleteIntegrationRecords({ collection, id, legalEntityId }) {
  if (id) {
    return deleteItemFromCollection(collection, id);
  }

  const items = await getItemsFromCollection(collection, {
    fields: ["id"],
    filter: {
      legal_entity: {
        _eq: legalEntityId,
      },
    },
    limit: -1,
  });

  if (!items?.length) {
    throw new Error("Integration not found");
  }

  const ids = items.map((item) => item.id);

  if (ids.length === 1) {
    return deleteItemFromCollection(collection, ids[0]);
  }

  return deleteItemsFromCollection(collection, ids);
}

export async function deleteEntityIntegration({ provider, id, legalEntityId }) {
  const collection = INTEGRATION_COLLECTIONS[provider];

  if (!collection) {
    throw new Error(`Unsupported integration provider: ${provider}`);
  }

  try {
    return await deleteIntegrationRecords({ collection, id, legalEntityId });
  } catch (error) {
    console.log(error);
    throw error;
  }
}
